import api, { apiError } from '../utilities/api';

const API_VERSION = 'v1';

export async function getReferralLink(
  referralCode: string,
  medium: string,
): Promise<{ data: { utmParamString: string; advocateName: string; rewardDescriptionText: string } }> {
  const path = `${API_VERSION}/referral-link/${referralCode}?medium=${medium}&_verify=1`;
  const method = 'GET';

  try {
    // @ts-ignore
    const {
      data,
    }: { data: { data: { utmParamString: string; advocateName: string; rewardDescriptionText: string } } } =
      await api.request({
        path,
        method,
      });
    return data;
  } catch (err) {
    throw apiError(err);
  }
}
